import autobind from "autobind-decorator";
import {extendObservable, observable} from "mobx";

@autobind
class MatchSingleOddModel {
    @observable
    createdAt = null
    @observable
    draw = null
    @observable
    id = null
    @observable
    isActive = null
    @observable
    line = null
    @observable
    loss = null
    @observable
    marketType = null
    @observable
    oddsSite = null
    @observable
    updatedAt = null
    @observable
    winStatus  = null
    @observable
    lossStatus  = null
    @observable
    drawStatus  = null

    constructor(data) {
        extendObservable(this, data);
    }
}

export default MatchSingleOddModel;